<template>
    <div>
        <!-- Alerta informativo para edição -->
        <div class="alert alert-info mt-4" v-if="isEditing">
            <i class="fas fa-info-circle mr-2"></i>
            Você só precisa preencher os campos de senha caso deseje alterá-la.
        </div>

        <div class="row">
            <!-- Senha -->
            <div class="col-md-6">
                <div class="form-group">
                    <label for="userPassword">
                        <span v-if="!isEditing" class="required">*</span>
                        Senha
                    </label>
                    <div class="password-input-container">
                        <input
                            :type="showPassword ? 'text' : 'password'"
                            class="form-control"
                            id="userPassword"
                            :value="passwordValue"
                            @input="updatePassword($event.target.value)"
                            autocomplete="new-password"
                        />
                        <button
                            type="button"
                            class="password-toggle-btn"
                            @click="togglePasswordVisibility"
                            tabindex="-1"
                        >
                            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Confirmação de Senha -->
            <div class="col-md-6">
                <div class="form-group">
                    <label for="userPasswordConfirmation">
                        <span v-if="!isEditing" class="required">*</span>
                        Confirme a Senha
                    </label>
                    <div class="password-input-container">
                        <input
                            :type="showPasswordConfirmation ? 'text' : 'password'"
                            class="form-control"
                            id="userPasswordConfirmation"
                            :value="value.password_confirmation"
                            @input="updateField('password_confirmation', $event.target.value)"
                            autocomplete="new-password"
                        />
                        <button
                            type="button"
                            class="password-toggle-btn"
                            @click="togglePasswordConfirmationVisibility"
                            tabindex="-1"
                        >
                            <i :class="showPasswordConfirmation ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserPasswordSection',
    props: {
        value: {
            type: Object,
            required: true
        },
        isEditing: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            showPassword: false,
            showPasswordConfirmation: false,
        };
    },
    computed: {
        passwordValue() {
            return this.isEditing ? this.value.passwordEdit : this.value.password;
        },
    },
    methods: {
        updateField(field, value) {
            this.$emit('update', field, value);
        },

        updatePassword(value) {
            const field = this.isEditing ? 'passwordEdit' : 'password';
            this.updateField(field, value);
        },

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },

        togglePasswordConfirmationVisibility() {
            this.showPasswordConfirmation = !this.showPasswordConfirmation;
        },
    }
};
</script>

<style scoped>
.alert {
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 12px 16px;
}

.alert-info {
    background-color: #d1ecf1;
    border-color: #bee5eb;
    color: #0c5460;
}

.form-group {
    margin-bottom: 1rem;
}

.form-group label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
    display: block;
}

.required {
    color: #dc3545;
    font-weight: bold;
    margin-right: 4px;
}

.password-input-container {
    position: relative;
}

.form-control {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0.375rem 0.75rem;
    padding-right: 40px; /* Espaço para o botão de visualizar */
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    font-size: 14px;
}

.form-control:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control::placeholder {
    color: #6c757d;
    opacity: 1;
}

.password-toggle-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
    border-radius: 3px;
    transition: color 0.15s ease-in-out;
}

.password-toggle-btn:hover {
    color: #495057;
}

.password-toggle-btn:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/User/form-components/UserPasswordSection.vue